// src/pages/Developers.jsx
import React, { useContext } from 'react';
import { AppContext } from './AppContext';
import { Link } from 'react-router-dom';

//import Header from '../components/Header';
import Footer from './Footer';
import { Helmet } from 'react-helmet';
import Header from './Header';


export default function Developers() {
    const { developersData } = useContext(AppContext);
    const developers = developersData?.developers || [];
    // Only show developers that have a logo, then sort by sequence with alphabetical fallback
    const withLogo = developers
        .filter(dev => dev.logo)
        .sort((a, b) => {
            const sa = a.sequence ? Number(a.sequence) : Infinity;
            const sb = b.sequence ? Number(b.sequence) : Infinity;
            if (sa !== sb) {
                return sa - sb;
            }
            // same sequence (or both missing): sort by name
            return a.name.localeCompare(b.name);
        });

    return (
        <div>

            <Helmet>
                <title>Best Real Estate Developers in Kolkata - PropXplorer</title>
                <meta
                    name="description"
                    content="At PropXplorer, explore the wide range of commercial and residential properties from the best real estate developers in Kolkata."
                />
                <meta
                    name="keywords"
                    content="Real Estate, Properties, Homes, Apartments, PropXplorer"
                />
            </Helmet>

            <Header />

            {/* Banner */}
            <div
                className="relative w-full h-[200px] md:h-[250px] lg:h-[300px] bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/developers-banner.jpg)`
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white px-5">
                    <h1 className="text-xl md:font-semibold md:text-2xl lg:text-3xl uppercase tracking-widest text-center">
                        DEVELOPERS WE COLLABORATE WITH
                    </h1>
                    <p className="text-sm md:text-base lg:text-lg mt-2 max-w-2xl text-center">
                        Your gateway to premium properties by top developers in Kolkata
                    </p>
                </div>
            </div>

            {/* Developer Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 p-4 lg:py-10 lg:px-20">
                {withLogo.map(dev => (
                    <Link
                        to={`/developer/${dev.slug}`}
                        key={dev.slug}
                        className="flex flex-col items-center text-center p-5 border rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow"
                    >
                        {dev.logo && (
                            <div className="h-24 flex items-center justify-center mb-4">

                                <img
                                    src={dev.logo}
                                    alt={dev.name}
                                    className="max-h-full object-contain"
                                />
                            </div>
                        )}
                        <h3 className="text-lg font-bold text-gray-800">{dev.name}</h3>
                    </Link>
                ))}
            </div>

            <h4 className="text-center mb-5">…and many more esteemed partners.</h4>
            <Footer />
        </div>
    );
}
